var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.541 34.375C16.9928 34.375 19.791 31.5768 19.791 28.125C19.791 24.6732 16.9928 21.875 13.541 21.875C10.0892 21.875 7.29102 24.6732 7.29102 28.125C7.29102 31.5768 10.0892 34.375 13.541 34.375Z",
    stroke: "black",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.541 21.8752C13.541 16.146 15.6243 5.2085 24.9993 5.2085C29.6868 5.2085 38.2493 7.63766 34.9327 21.4179C34.641 22.6325 33.4931 24.9741 33.4931 24.9741L31.8223 28.7262C30.0941 32.2064 27.8618 41.0981 34.9327 44.3866C37.0764 45.3835 41.6837 44.7397 42.7077 40.2095",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeo);
export default __webpack_public_path__ + "static/media/leo.342b5e2d0be880ebc1a50f6ca3493bb6.svg";
export { ForwardRef as ReactComponent };